(() => {
  const ROOT_SEL = '[data-cart-drawer]';

  function shieldIcon(root) {
    const src = root?.getAttribute('data-protection-icon') || '';
    if (src) {
      return `<img src="${src}" alt="" width="28" height="28" decoding="async">`;
    }
    return `
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l7 3v5c0 4.5-2.9 7.8-7 9-4.1-1.2-7-4.5-7-9V6l7-3z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/>
        <path d="M9.5 12.2l1.8 1.8 3.4-3.6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  const routes = {
    root: window.Shopify?.routes?.root || '/',
    cart: () => `${routes.root}cart.js`,
    add: () => `${routes.root}cart/add.js`,
    change: () => `${routes.root}cart/change.js`
  };

  const PROTECTION_OPT_OUT_KEY = 'capblast-shipping-protection-opt-out';

  const qs = (el, sel) => el.querySelector(sel);

  function formatMoney(cents, format) {
    if (typeof window.ccFmt === 'function') return window.ccFmt(Number(cents) || 0);
    const safe = Number(cents);
    const amount = Number.isFinite(safe) ? safe : 0;
    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, format);
    }
    const value = amount / 100;
    const formatted = value.toFixed(2);
    if (!format) return `$${formatted}`;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value)))
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function cartUrl(path) {
    return path.startsWith('http') ? path : path;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function emptyDemoCart() {
    return {
      items: [],
      item_count: 0,
      total_price: 0,
      items_subtotal_price: 0,
      demo: true
    };
  }

  function parseMoneyToCents(text) {
    const cleaned = String(text || '').replace(/[^0-9.,]/g, '');
    if (!cleaned) return 0;
    const normalized = cleaned.includes(',') && !cleaned.includes('.')
      ? cleaned.replace(',', '.')
      : cleaned.replace(/,/g, '');
    const value = parseFloat(normalized);
    if (Number.isNaN(value)) return 0;
    return Math.round(value * 100);
  }

  function recountDemoCart(cart) {
    const items = cart.items || [];
    const total = items.reduce((sum, item) => sum + (Number(item.final_line_price ?? item.line_price) || 0), 0);
    const count = items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    cart.total_price = total;
    cart.items_subtotal_price = total;
    cart.item_count = count;
    cart.demo = true;
    return cart;
  }

  // cc: quantity bundle tiers (must match the automatic discounts in Shopify admin)
  const BUNDLE_TIERS = [
    { qty: 2, cents: 200, label: '$2' },
    { qty: 3, cents: 400, label: '$4' }
  ];
  const GIFTS_PER_ITEM = 2;

  function tierDiscountCents(qty) {
    let cents = 0;
    BUNDLE_TIERS.forEach((tier) => {
      if (qty >= tier.qty) cents = tier.cents;
    });
    return cents;
  }

  function ccText(key, fallback, vars) {
    let s = (window.ccT && window.ccT[key]) || fallback;
    Object.entries(vars || {}).forEach(([k, v]) => { s = s.split('%' + k + '%').join(v); });
    return s;
  }

  function promoHtml(qty) {
    if (!qty || qty < 1) return '';
    const m = (usd) => (typeof window.ccFmt === 'function' ? window.ccFmt(window.ccConv(usd), true) : '$' + usd / 100);
    const v = { S2: '<strong>' + m(200) + '</strong>', S4: '<strong>' + m(400) + '</strong>' };
    const plain = { S2: m(200), S4: m(400) };
    let status;
    if (qty >= 3) status = ccText('best', '🎉 Best deal unlocked — you save %S4%!', v);
    else if (qty === 2) status = ccText('saving_two', '🎉 You save %S2%! Add 1 more to save %S4%', v);
    else status = ccText('add_one', 'Add 1 more cable & save %S2%', v);
    const gifts = qty * GIFTS_PER_ITEM;
    return `
      <p class="cart-promo__status">${status}</p>
      <ul class="cart-promo__tiers" role="list">
        <li class="${qty === 2 ? 'is-active' : ''}">${escapeHtml(ccText('tier_two', 'Buy 2 — save %S2%', plain))}</li>
        <li class="${qty >= 3 ? 'is-active' : ''}">${escapeHtml(ccText('tier_three', 'Buy 3 — save %S4%', plain))}</li>
      </ul>
      <p class="cart-promo__gifts">🎁 <strong>${escapeHtml(ccText('gifts', '%N% FREE secret gifts', { N: gifts }))}</strong> ${escapeHtml(ccText('gifts_rest', 'included · 2 with every cable'))}</p>
    `;
  }

  class CartDrawerController {
    constructor(root) {
      this.root = root;
      this.panel = qs(root, '.cart-drawer');
      this.overlay = qs(root, '[data-cart-drawer-overlay]');
      this.itemsEl = qs(root, '[data-cart-drawer-items]');
      this.emptyEl = qs(root, '[data-cart-drawer-empty]');
      this.footerEl = qs(root, '[data-cart-drawer-footer]');
      this.countEl = qs(root, '[data-cart-drawer-count]');
      this.subtotalEl = qs(root, '[data-cart-drawer-subtotal]');
      this.promoEl = qs(root, '[data-cart-drawer-promo]');
      this.discountRowEl = qs(root, '[data-cart-drawer-discount-row]');
      this.discountEl = qs(root, '[data-cart-drawer-discount]');
      this.closeBtn = qs(root, '[data-cart-drawer-close]');
      this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
      this.protectionVariantId = root.getAttribute('data-protection-variant-id') || '';
      this.protectionLabel = root.getAttribute('data-protection-label') || 'Shipping Protection';
      this.isOpen = false;
      this.busy = false;
      this.lastFocus = null;
      this.demoMode = false;
      this.demoCart = emptyDemoCart();
      this.demoProtectionCents = 299;

      this.onKeyDown = this.onKeyDown.bind(this);
      this.bindUI();
      this.bindGlobal();
    }

    bindUI() {
      this.overlay?.addEventListener('click', () => this.close());
      this.closeBtn?.addEventListener('click', () => this.close());
      qs(this.root, '[data-cart-drawer-continue]')?.addEventListener('click', () => this.close());

      this.root.addEventListener('click', (event) => {
        const origin = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!(origin instanceof Element)) return;
        const removeBtn = origin.closest('[data-line-remove]');
        if (removeBtn) {
          event.preventDefault();
          const row = removeBtn.closest('.cart-drawer__item');
          const key = removeBtn.getAttribute('data-line-key') || row?.getAttribute('data-line-key');
          const wasProtection = !!row?.hasAttribute('data-protection-line');
          this.change(key, 0, { wasProtection }).catch(() => {});
          return;
        }

        const qtyBtn = origin.closest('[data-qty-change]');
        if (qtyBtn) {
          event.preventDefault();
          if (qtyBtn.disabled) return;
          const row = qtyBtn.closest('.cart-drawer__item');
          if (!row) return;
          const key = row.getAttribute('data-line-key') || qtyBtn.getAttribute('data-line-key');
          const delta = parseInt(qtyBtn.getAttribute('data-qty-change') || '0', 10);
          const current = parseInt(qs(row, '[data-line-qty]')?.textContent?.trim() || '0', 10);
          if (!key || Number.isNaN(current) || Number.isNaN(delta)) return;
          const next = current + delta;
          if (next < 1 || next > 99) return;
          this.change(key, next).catch(() => {});
        }
      });

      this.root.addEventListener('change', (event) => {
        const origin = event.target instanceof Element ? event.target : null;
        if (!origin) return;
        const toggle = origin.closest('[data-cart-shipping-protection]');
        if (!toggle) return;
        this.onDrawerProtectionToggle(!!toggle.checked).catch(() => {});
      });
    }

    bindGlobal() {
      document.addEventListener('click', (event) => {
        const origin = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!(origin instanceof Element)) return;
        const openTrigger = origin.closest('[data-cart-open]');
        if (!openTrigger) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.open();
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const isSticky = form.matches('.sticky-atc__form') || form.hasAttribute('data-cart-ajax');
        if (isSticky) {
          event.preventDefault();
          if (window.__capblastSubmitting || window.__capblastAtcSource === 'sticky') return;
          if (typeof window.CapBlastATC?.add === 'function') {
            window.__capblastSubmitting = true;
            window.__capblastAtcSource = 'sticky';
            window.CapBlastATC.sync?.();
            window.CapBlastATC.add()
              .then(async (mode) => {
                if (mode === 'demo' || this.demoMode) {
                  this.open();
                  return;
                }
                if (mode === 'live') {
                  await this.refresh();
                  this.open();
                }
              })
              .catch(() => {})
              .finally(() => {
                window.__capblastSubmitting = false;
                window.__capblastAtcSource = '';
              });
          }
          return;
        }

        if (form.matches('[data-product-form]')) {
          const hasBundles = form.closest('[data-main-product]')?.querySelector('[data-bundle-picker]');
          if (hasBundles) return;
        }

        const isCartAdd =
          (form.getAttribute('action') || '').includes('/cart/add') ||
          form.matches('form[action*="/cart/add"]');

        if (!isCartAdd && !form.matches('[data-product-form]')) return;

        event.preventDefault();
        this.addFromForm(form).catch(() => {});
      });

      document.addEventListener('change', (event) => {
        const origin = event.target instanceof Element ? event.target : null;
        if (!origin) return;
        if (origin.closest('[data-cart-shipping-protection]')) return;
        const productToggle = origin.closest('[data-shipping-protection]');
        if (!productToggle) return;
        this.onDrawerProtectionToggle(!!productToggle.checked).catch(() => {});
      });
    }

    setBusy(state) {
      this.busy = state;
      this.root.classList.toggle('is-busy', state);
    }

    open() {
      if (this.isOpen) return;
      this.lastFocus = document.activeElement;
      this.isOpen = true;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      this.root.removeAttribute('inert');
      document.body.classList.add('is-cart-drawer-open');
      document.addEventListener('keydown', this.onKeyDown);
      requestAnimationFrame(() => {
        (this.closeBtn || this.panel)?.focus?.();
      });
      this.ensureDefaultProtection().catch(() => {});
      if (!this.demoMode && !this.busy) this.refresh().catch(() => {});
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      this.root.setAttribute('inert', '');
      document.body.classList.remove('is-cart-drawer-open');
      document.removeEventListener('keydown', this.onKeyDown);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
    }

    toggle() {
      if (this.isOpen) this.close();
      else this.open();
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
    }

    updateBadge(itemCount) {
      const badges = document.querySelectorAll('.header__cart-badge');
      badges.forEach((badge) => {
        badge.textContent = String(itemCount);
        badge.classList.toggle('is-empty', itemCount <= 0);
      });
      document.querySelectorAll('.header__cart').forEach((link) => {
        link.setAttribute(
          'aria-label',
          itemCount > 0 ? `Cart (${itemCount})` : 'Cart'
        );
      });
    }

    updateCountLabel(itemCount) {
      if (!this.countEl) return;
      this.countEl.textContent = itemCount === 1 ? ccText('item_one', '1 item') : ccText('item_other', '%N% items', { N: itemCount });
    }

    getProtectionVariantId() {
      const raw =
        this.protectionVariantId ||
        document.querySelector('[data-shipping-protection-variant]')?.getAttribute('data-shipping-protection-variant') ||
        '';
      const id = String(raw || '').trim();
      if (!id) return '';
      const num = Number(id);
      if (!Number.isFinite(num) || num <= 0 || String(Math.trunc(num)) !== id) return '';
      return id;
    }

    isProtectionOptedOut() {
      try {
        return sessionStorage.getItem(PROTECTION_OPT_OUT_KEY) === '1';
      } catch {
        return false;
      }
    }

    setProtectionOptOut(optedOut) {
      try {
        if (optedOut) sessionStorage.setItem(PROTECTION_OPT_OUT_KEY, '1');
        else sessionStorage.removeItem(PROTECTION_OPT_OUT_KEY);
      } catch {}
    }

    isProtectionDefaultOn() {
      const host = document.querySelector('[data-shipping-protection-default]');
      if (host) return host.getAttribute('data-shipping-protection-default') !== 'false';
      return !!document.querySelector('[data-shipping-protection], [data-cart-shipping-protection]');
    }

    wantsProtection() {
      if (this.isProtectionOptedOut()) return false;
      if (this.isProtectionDefaultOn()) return true;
      return !!document.querySelector('[data-shipping-protection]:checked, [data-cart-shipping-protection]:checked');
    }

    isProtectionItem(item) {
      const props = item.properties || {};
      if (props._shipping_protection === '1') return true;
      if (props['Shipping Protection'] === 'Yes' && item.handle === 'shipping-protection') return true;
      const variantId = this.getProtectionVariantId();
      if (variantId && String(item.id) === String(variantId)) return true;
      if (item.handle === 'shipping-protection') return true;
      const title = (item.product_title || item.title || '').toLowerCase();
      return title === 'shipping protection';
    }

    visibleProperties(item) {
      const props = item.properties || {};
      const skip = new Set(['Shipping Protection', 'Bundle']);
      return Object.entries(props).filter(([key, value]) => {
        if (!key || key.charAt(0) === '_') return false;
        if (value == null || value === '') return false;
        if (skip.has(key)) return false;
        return true;
      });
    }

    formatProperty([key, value]) {
      if (key === 'Volumes' || key === 'Unit' || key === 'Bundle' || key.includes('Volume')) {
        return escapeHtml(String(value));
      }
      return `${escapeHtml(key)}: ${escapeHtml(String(value))}`;
    }

    renderProtectionItem(item) {
      const key = escapeHtml(item.key);
      const price = formatMoney(item.final_line_price ?? item.line_price, this.moneyFormat);
      const label = escapeHtml(this.protectionLabel);

      return `
        <li class="cart-drawer__item cart-drawer__item--protection" data-line-key="${key}" data-protection-line>
          <div class="cart-drawer__item-media cart-drawer__item-media--icon" aria-hidden="true">
            ${shieldIcon(this.root)}
          </div>
          <div class="cart-drawer__item-info">
            <div class="cart-drawer__item-top">
              <span class="cart-drawer__item-title">${label}</span>
              <p class="cart-drawer__item-price" data-line-price>${price}</p>
            </div>
            <div class="cart-drawer__item-actions cart-drawer__item-actions--protection">
              <span class="visually-hidden" data-line-qty>${item.quantity}</span>
              <button
                type="button"
                class="cart-drawer__remove cart-drawer__remove--icon"
                data-line-remove
                data-line-key="${key}"
                aria-label="Remove ${label}"
              >✕</button>
            </div>
          </div>
        </li>
      `;
    }

    renderProductItem(item) {
      const image = item.image
        ? `<img class="cart-drawer__item-image" src="${escapeHtml(String(item.image) + (String(item.image).includes('?') ? '&' : '?') + 'width=160')}" alt="${escapeHtml(item.product_title || '')}" width="80" height="80" loading="lazy">`
        : `<div class="cart-drawer__item-image cart-drawer__item-image--placeholder" aria-hidden="true"></div>`;

      const variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>`
          : '';

      const props = this.visibleProperties(item);
      const propsHtml = props.length
        ? `<ul class="cart-drawer__item-props">${props
            .map((entry) => `<li>${this.formatProperty(entry)}</li>`)
            .join('')}</ul>`
        : '';

      const key = escapeHtml(item.key);
      const price = formatMoney(item.final_line_price ?? item.line_price, this.moneyFormat);
      const originalCents = Number(item.original_line_price ?? item.line_price) || 0;
      const finalCents = Number(item.final_line_price ?? item.line_price) || 0;
      const compare = originalCents > finalCents
        ? `<s class="cart-drawer__item-compare">${formatMoney(originalCents, this.moneyFormat)}</s> `
        : '';
      const qty = Number(item.quantity) || 1;

      return `
        <li class="cart-drawer__item" data-line-key="${key}">
          <div class="cart-drawer__item-media">${image}</div>
          <div class="cart-drawer__item-info">
            <div class="cart-drawer__item-top">
              <a href="${escapeHtml(cartUrl(item.url || '#'))}" class="cart-drawer__item-title">${escapeHtml(item.product_title || '')}</a>
              <p class="cart-drawer__item-price" data-line-price>${compare}${price}</p>
            </div>
            ${variant}
            ${propsHtml}
            <div class="cart-drawer__item-actions">
              <div class="cart-drawer__qty" role="group" aria-label="${escapeHtml(ccText('quantity', 'Quantity'))}">
                <button type="button" class="cart-drawer__qty-btn" data-qty-change="-1" aria-label="${escapeHtml(ccText('decrease', 'Decrease quantity'))}" ${qty <= 1 ? 'disabled' : ''}>−</button>
                <span class="cart-drawer__qty-value" data-line-qty aria-live="polite">${qty}</span>
                <button type="button" class="cart-drawer__qty-btn" data-qty-change="1" aria-label="${escapeHtml(ccText('increase', 'Increase quantity'))}">+</button>
              </div>
              <button type="button" class="cart-drawer__remove" data-line-remove data-line-key="${key}">${escapeHtml(ccText('remove', 'Remove'))}</button>
            </div>
          </div>
        </li>
      `;
    }

    renderItem(item) {
      return this.isProtectionItem(item)
        ? this.renderProtectionItem(item)
        : this.renderProductItem(item);
    }

    isDemoKey(key) {
      return String(key || '').startsWith('demo-');
    }

    getDemoProtectionPrice() {
      const labeled = document.querySelector('.product-trust__protect-price, .cart-drawer__protect-price');
      return parseMoneyToCents(labeled?.textContent) || this.demoProtectionCents || 299;
    }

    demoProductKey(item) {
      const props = item.properties || {};
      return String(props.Bundle || '').replace(/\s+/g, ' ').trim() || String(item.handle || item.id || '');
    }

    isCapBlastProduct(item) {
      if (!item || this.isProtectionItem(item)) return false;
      const handle = String(item.handle || '').toLowerCase();
      const title = String(item.product_title || item.title || '').toLowerCase();
      if (handle === 'the-capblast' || handle === 'capblast' || handle === 'cap-blast') return true;
      if (String(item.id) === 'demo-capblast') return true;
      if (title.includes('capblast') || title.includes('cap blast')) return true;
      if (item.properties?.Bundle) return true;
      return false;
    }

    getCapBlastImage() {
      return (
        document.querySelector('[data-main-product]')?.getAttribute('data-capblast-image') ||
        this.root.getAttribute('data-capblast-image') ||
        ''
      );
    }

    applyCustomProductImage(src) {
      const image = src || this.getCapBlastImage();
      if (!image) return image;
      this.root.setAttribute('data-capblast-image', image);
      this.root.querySelectorAll('.cart-drawer__item:not([data-protection-line]) img.cart-drawer__item-image').forEach((img) => {
        img.src = image;
      });
      document.querySelectorAll('.sticky-atc__image').forEach((img) => {
        img.src = image;
      });
      return image;
    }

    normalizeCapBlastItem(item) {
      if (!this.isCapBlastProduct(item)) return item;
      const image = this.getCapBlastImage() || item.image || '';
      if (!this.demoMode) {
        return image && image !== item.image ? { ...item, image } : item;
      }
      return {
        ...item,
        product_title: 'The CapBlast',
        title: 'The CapBlast',
        handle: item.handle || 'the-capblast',
        image
      };
    }

    mergeDemoCart(existing, incoming) {
      const base = {
        items: Array.isArray(existing?.items) ? existing.items.map((item) => ({ ...item })) : [],
        item_count: 0,
        total_price: 0,
        items_subtotal_price: 0,
        demo: true
      };
      const incomingItems = Array.isArray(incoming?.items) ? incoming.items : [];

      incomingItems.forEach((raw) => {
        const item = this.normalizeCapBlastItem({ ...raw });
        if (this.isProtectionItem(item)) {
          const hasProtection = base.items.some((line) => this.isProtectionItem(line));
          if (!hasProtection) base.items.push(item);
          return;
        }

        const key = this.demoProductKey(item);
        const match = base.items.find(
          (line) => !this.isProtectionItem(line) && this.demoProductKey(line) === key
        );
        if (match) {
          const unit =
            Number(match.price) ||
            Number(item.price) ||
            Math.round(
              (Number(match.final_line_price ?? match.line_price) || 0) /
                Math.max(Number(match.quantity) || 1, 1)
            );
          const addQty = Math.max(1, Number(item.quantity) || 1);
          match.quantity = (Number(match.quantity) || 0) + addQty;
          match.price = unit;
          match.line_price = unit * match.quantity;
          match.final_line_price = unit * match.quantity;
          if (item.image && !match.image) match.image = item.image;
          if (item.variant_title) match.variant_title = item.variant_title;
          match.properties = { ...(match.properties || {}), ...(item.properties || {}) };
          return;
        }

        const usedKeys = new Set(base.items.map((line) => String(line.key)));
        let nextKey = String(item.key || `demo-capblast-${base.items.length + 1}`);
        if (usedKeys.has(nextKey)) {
          let i = base.items.length + 1;
          do {
            nextKey = `demo-capblast-${i++}`;
          } while (usedKeys.has(nextKey));
        }
        item.key = nextKey;
        base.items.push(item);
      });

      return recountDemoCart(base);
    }

    showDemo(cart) {
      const next = cart && typeof cart === 'object' ? cart : emptyDemoCart();
      const incomingItems = Array.isArray(next.items)
        ? next.items.map((item) => this.normalizeCapBlastItem({ ...item }))
        : [];
      const hadDemoItems = this.demoMode && (this.demoCart?.items?.length || 0) > 0;

      this.demoMode = true;
      this.demoCart = hadDemoItems
        ? this.mergeDemoCart(this.demoCart, { items: incomingItems })
        : recountDemoCart({
            items: incomingItems,
            item_count: next.item_count || 0,
            total_price: next.total_price || 0,
            items_subtotal_price: next.items_subtotal_price || next.total_price || 0,
            demo: true
          });

      const protectPrice = (this.demoCart.items || []).find((item) => this.isProtectionItem(item));
      if (protectPrice) {
        this.demoProtectionCents = Number(protectPrice.final_line_price || protectPrice.line_price) || 299;
      } else {
        this.demoProtectionCents = this.getDemoProtectionPrice();
      }

      const row = qs(this.root, '[data-cart-protection-row]');
      row?.removeAttribute('data-protection-unavailable');
      const toggle = qs(this.root, '[data-cart-shipping-protection]');
      if (toggle) toggle.disabled = false;
      document.querySelectorAll('[data-shipping-protection]').forEach((el) => {
        el.disabled = false;
      });

      this.render(this.demoCart);
      return this.demoCart;
    }

    clearDemo() {
      this.demoMode = false;
      this.demoCart = emptyDemoCart();
    }

    render(cart) {
      if (!this.itemsEl) return;

      const rawItems = (cart.items || []).map((item) => this.normalizeCapBlastItem(item));
      const items = [...rawItems].sort((a, b) => {
        const aProt = this.isProtectionItem(a) ? 0 : 1;
        const bProt = this.isProtectionItem(b) ? 0 : 1;
        return aProt - bProt;
      });
      const count = items
        .filter((item) => !this.isProtectionItem(item))
        .reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      const empty = count === 0;

      this.itemsEl.innerHTML = items.map((item) => this.renderItem(item)).join('');
      this.itemsEl.classList.toggle('is-hidden', empty);
      this.emptyEl?.classList.toggle('is-hidden', !empty);
      this.footerEl?.classList.toggle('is-hidden', empty);

      const productQty = items
        .filter((item) => !this.isProtectionItem(item))
        .reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      let totalCents = Number(cart.total_price ?? cart.items_subtotal_price) || 0;
      let discountCents = Number(cart.total_discount) || 0;
      if (cart.demo || this.demoMode) {
        discountCents = typeof window.ccConv === 'function' ? window.ccConv(tierDiscountCents(productQty)) : tierDiscountCents(productQty);
        totalCents = Math.max(0, totalCents - discountCents);
      }

      if (this.subtotalEl) {
        this.subtotalEl.textContent = formatMoney(totalCents, this.moneyFormat);
      }
      if (this.discountRowEl) {
        this.discountRowEl.classList.toggle('is-hidden', discountCents <= 0);
        if (this.discountEl) this.discountEl.textContent = '−' + formatMoney(discountCents, this.moneyFormat);
      }
      if (this.promoEl) {
        this.promoEl.innerHTML = promoHtml(productQty);
        this.promoEl.classList.toggle('is-hidden', productQty < 1);
      }

      this.updateCountLabel(count);
      this.updateBadge(count);
      this.syncProtectionToggle(this.cartHasProtection(cart));

      const protectPriceEl = qs(this.root, '.cart-drawer__protect-price');
      if (protectPriceEl && this.demoMode) {
        protectPriceEl.textContent = formatMoney(this.getDemoProtectionPrice(), this.moneyFormat);
      }
    }

    async refresh() {
      if (this.demoMode) {
        await this.ensureDefaultProtection();
        this.render(this.demoCart);
        return this.demoCart;
      }

      const response = await fetch(routes.cart(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Failed to fetch cart');
      let cart = await response.json();
      const added = await this.tryAddProtectionSeparately(cart);
      if (added) {
        cart = await this.fetchCart();
      }
      this.render(cart);
      return cart;
    }

    syncProtectionToggle(checked) {
      document.querySelectorAll('[data-shipping-protection], [data-cart-shipping-protection]').forEach((el) => {
        el.checked = !!checked;
      });
    }

    async onDrawerProtectionToggle(enabled) {
      if (this.busy) {
        this.syncProtectionToggle(!enabled);
        return;
      }

      this.setProtectionOptOut(!enabled);

      if (this.demoMode) {
        this.setBusy(true);
        try {
          const has = this.cartHasProtection(this.demoCart);
          if (enabled && !has) {
            const cents = this.getDemoProtectionPrice();
            this.demoCart.items = [
              {
                key: 'demo-shipping-protection',
                id: 'demo-shipping-protection',
                product_title: this.protectionLabel || 'Shipping Protection',
                variant_title: null,
                handle: 'shipping-protection',
                quantity: 1,
                price: cents,
                line_price: cents,
                final_line_price: cents,
                image: '',
                url: '#',
                properties: { _shipping_protection: '1' }
              },
              ...(this.demoCart.items || [])
            ];
            recountDemoCart(this.demoCart);
            this.render(this.demoCart);
            this.syncProtectionToggle(true);
            return;
          }

          if (!enabled && has) {
            this.demoCart.items = (this.demoCart.items || []).filter((item) => !this.isProtectionItem(item));
            recountDemoCart(this.demoCart);
            this.render(this.demoCart);
            this.syncProtectionToggle(false);
            return;
          }

          this.syncProtectionToggle(has);
        } finally {
          this.setBusy(false);
        }
        return;
      }

      const variantId = this.getProtectionVariantId();
      if (!variantId) {
        this.syncProtectionToggle(false);
        return;
      }

      this.setBusy(true);
      try {
        const cart = await this.fetchCart();
        const has = this.cartHasProtection(cart, variantId);
        if (enabled && !has) {
          const response = await fetch(routes.add(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId) || variantId,
                  quantity: 1,
                  properties: { _shipping_protection: '1' }
                }
              ]
            })
          });
          if (!response.ok) throw new Error('Add protection failed');
          this.clearDemo();
          await this.refresh();
          this.syncProtectionToggle(true);
          return;
        }

        if (!enabled && has) {
          const line = (cart.items || []).find((item) => this.isProtectionItem(item));
          if (line?.key) {
            await this.change(line.key, 0, { wasProtection: true, force: true });
            return;
          }
        }

        this.syncProtectionToggle(has);
      } catch {
        this.syncProtectionToggle(false);
        try {
          await this.refresh();
        } catch {}
      } finally {
        this.setBusy(false);
      }
    }

    async fetchCart() {
      if (this.demoMode) return this.demoCart;
      const response = await fetch(routes.cart(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    }

    async change(key, quantity, options = {}) {
      if (!key || (this.busy && !options.force)) return;
      const removingProtection = quantity === 0 && !!options.wasProtection;

      if (this.demoMode || this.isDemoKey(key)) {
        this.setBusy(true);
        try {
          this.demoMode = true;
          if (quantity <= 0) {
            this.demoCart.items = (this.demoCart.items || []).filter((item) => item.key !== key);
          } else {
            this.demoCart.items = (this.demoCart.items || []).map((item) => {
              if (item.key !== key) return item;
              const unit = Number(item.price) || Math.round((Number(item.final_line_price) || 0) / Math.max(item.quantity || 1, 1));
              return {
                ...item,
                quantity,
                line_price: unit * quantity,
                final_line_price: unit * quantity
              };
            });
          }
          recountDemoCart(this.demoCart);
          this.render(this.demoCart);
          if (removingProtection || (quantity === 0 && !this.cartHasProtection(this.demoCart))) {
            this.setProtectionOptOut(true);
            this.syncProtectionToggle(false);
          }
        } finally {
          this.setBusy(false);
        }
        return;
      }

      this.setBusy(true);
      try {
        const response = await fetch(routes.change(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) throw new Error('Cart change failed');
        let cart = await response.json();
        this.clearDemo();
        const orphan = (cart.items || []).length > 0 && (cart.items || []).every((item) => this.isProtectionItem(item));
        if (orphan) {
          const line = cart.items[0];
          const res2 = await fetch(routes.change(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: line.key, quantity: 0 }) });
          if (res2.ok) cart = await res2.json();
        }
        this.render(cart);
        if (removingProtection || (quantity === 0 && !this.cartHasProtection(cart))) {
          this.setProtectionOptOut(true);
          this.syncProtectionToggle(false);
        }
      } catch {
        let refreshed = false;
        try {
          await this.refresh();
          refreshed = true;
        } catch {}
        if (!refreshed) this.close();
      } finally {
        this.setBusy(false);
      }
    }

    formToItems(form) {
      const data = new FormData(form);
      const id = data.get('id');
      const quantity = Number(data.get('quantity') || 1);
      if (!id) return [];

      const properties = {};
      data.forEach((value, name) => {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && value !== '') {
          if (match[1] === 'Shipping Protection') return;
          properties[match[1]] = String(value);
        }
      });

      const item = { id: Number(id) || id, quantity: quantity > 0 ? quantity : 1 };
      if (Object.keys(properties).length) item.properties = properties;
      return [item];
    }

    cartHasProtection(cart, variantId) {
      const id = String(variantId || '');
      return (cart.items || []).some((item) => {
        if (this.isProtectionItem(item)) return true;
        return id && String(item.id) === id;
      });
    }

    async tryAddProtectionSeparately(existingCart) {
      if (!this.wantsProtection()) return false;
      const variantId = this.getProtectionVariantId();
      if (!variantId) return false;

      try {
        const cart = existingCart || (await this.fetchCart());
        const hasProduct = (cart.items || []).some((item) => !this.isProtectionItem(item));
        if (!hasProduct) return false;
        if (this.cartHasProtection(cart, variantId)) {
          this.syncProtectionToggle(true);
          return false;
        }

        const response = await fetch(routes.add(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId) || variantId,
                quantity: 1,
                properties: { _shipping_protection: '1' }
              }
            ]
          })
        });
        if (!response.ok) {
          this.syncProtectionToggle(false);
          return false;
        }
        this.syncProtectionToggle(true);
        return true;
      } catch {
        this.syncProtectionToggle(false);
        return false;
      }
    }

    async ensureDefaultProtection() {
      if (!this.wantsProtection()) return;

      if (this.demoMode) {
        const cart = this.demoCart;
        const hasProduct = (cart.items || []).some((item) => !this.isProtectionItem(item));
        if (!hasProduct || this.cartHasProtection(cart)) {
          if (this.cartHasProtection(cart)) this.syncProtectionToggle(true);
          return;
        }
        const cents = this.getDemoProtectionPrice();
        this.demoCart.items = [
          {
            key: 'demo-shipping-protection',
            id: 'demo-shipping-protection',
            product_title: this.protectionLabel || 'Shipping Protection',
            variant_title: null,
            handle: 'shipping-protection',
            quantity: 1,
            price: cents,
            line_price: cents,
            final_line_price: cents,
            image: '',
            url: '#',
            properties: { _shipping_protection: '1' }
          },
          ...(this.demoCart.items || [])
        ];
        recountDemoCart(this.demoCart);
        this.syncProtectionToggle(true);
        this.render(this.demoCart);
        return;
      }

      const added = await this.tryAddProtectionSeparately();
      if (added && this.isOpen) {
        try {
          const cart = await this.fetchCart();
          this.render(cart);
        } catch {}
      }
    }

    async addFromForm(form) {
      if (this.busy) return;
      const items = this.formToItems(form);
      if (!items.length) {
        if (window.CapBlastATC?.demo) {
          await window.CapBlastATC.demo();
          return;
        }
        form.submit();
        return;
      }

      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      this.setBusy(true);

      let added = false;
      try {
        const response = await fetch(routes.add(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Add to cart failed');
        added = true;
        this.clearDemo();
        await this.tryAddProtectionSeparately();
      } catch {
        if (window.CapBlastATC?.demo) {
          try {
            await window.CapBlastATC.demo();
          } catch {}
        } else if (form instanceof HTMLFormElement) {
          HTMLFormElement.prototype.submit.call(form);
        }
      }

      if (added) {
        try {
          await this.refresh();
          this.open();
        } catch {
          window.location.href = `${routes.root}cart`;
        }
      }

      this.setBusy(false);
      if (button) button.disabled = false;
    }
  }

  function init() {
    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    if (window.CartDrawer) {
      window.CartDrawer.syncProductImage?.();
      return;
    }

    const controller = new CartDrawerController(root);
    const syncProductImage = () => controller.applyCustomProductImage();
    window.CartDrawer = {
      open: () => controller.open(),
      close: () => controller.close(),
      toggle: () => controller.toggle(),
      refresh: () => controller.refresh(),
      change: (key, qty) => controller.change(key, qty),
      addFromForm: (form) => controller.addFromForm(form),
      showDemo: (cart) => controller.showDemo(cart),
      isDemo: () => controller.demoMode,
      syncProductImage
    };
    syncProductImage();
  }

  const onEditorEvent = () => {
    init();
    window.CartDrawer?.syncProductImage?.();
  };

  if (!window.__capblastCartEditorListeners) {
    window.__capblastCartEditorListeners = true;
    ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder'].forEach((evt) => {
      document.addEventListener(evt, onEditorEvent);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
